import { useCallback, useEffect, useState } from "react";
import useAxiosClient from "../axios-client";
import { toast } from "react-toastify";

export const useProductFormations = () => {

    const axiosClient = useAxiosClient();
    const [productFormations, setProductFormations] = useState([]);
    const [productFormationsLoading, setProductFormationsLoading] = useState(false);

    const fetchProductFormations = useCallback(async () => {
        setProductFormationsLoading(true);
        await axiosClient.get(`/settings/productFormations/index`).then((response) => {
            setProductFormations([...response.data.data])
            setProductFormationsLoading(false);
        }).catch((error) => {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            setProductFormationsLoading(false);
            toast.error(message);
        });
    }, [axiosClient])

    // Inline creation from the order form: returns the created (or, on a
    // duplicate, the already-existing) formation so the caller can select it,
    // and null when nothing usable came back.
    const createProductFormation = useCallback(async (name) => {
        const trimmed = (name || "").trim();
        if (!trimmed) return null;

        const remember = (item) => {
            setProductFormations((prev) =>
                prev.some((p) => p.id === item.id) ? prev : [...prev, item]
            );
            return item;
        };

        try {
            const response = await axiosClient.post(`/settings/productFormations/store`, { name: trimmed });
            toast.success(response.data.message);
            return remember(response.data.data);
        } catch (error) {
            const data = error.response && error.response.data;
            if (data?.data?.id) return remember(data.data);
            const message = (data && data.message) || error.message || error.toString();
            toast.error(message);
            return null;
        }
    }, [axiosClient])

    useEffect(() => {
        fetchProductFormations();
    }, [fetchProductFormations])

    return { productFormations, productFormationsLoading, fetchProductFormations, createProductFormation }
}
